import { useState, useEffect } from "react"

const useWindowSize = () => {
    const [size, setSize] = useState({
        widthW  : 0,
        heightW : 0
    })


    useEffect(() => {
        const updateSize = () => {
            const widthW = window.innerWidth
            setSize({
                widthW,
                heightW: window.innerHeight
            })
        }

        window.addEventListener("resize", updateSize)
        updateSize()

        return () => window.removeEventListener("resize", updateSize)
    }, [])

    return size
}

export default useWindowSize
